import { DataHelpers } from "@/core/modules/helpers/DataHelpers";

import { BooleanField } from "@/core/fields";

export class SurveyForm {
  public id: string = DataHelpers.uniqueId();
  public isCompleted = false;
  public isPrintable = false;

  public constructor(firestoreData?: Record<string, unknown>) {
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);
  }

  public fromFirestore(data: Record<string, unknown>): SurveyForm {
    this.id = DataHelpers.uniqueId();

    this.isCompleted = BooleanField.fromFirestore(data.isCompleted);
    this.isPrintable = BooleanField.fromFirestore(data.isPrintable);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = {};

    firestoreData.isCompleted = BooleanField.toFirestore(this.isCompleted);
    firestoreData.isPrintable = BooleanField.toFirestore(this.isPrintable);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): SurveyForm {
    this.id = DataHelpers.uniqueId();

    this.isCompleted = BooleanField.fromOfflineCache(data.isCompleted);
    this.isPrintable = BooleanField.fromOfflineCache(data.isPrintable);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = {};

    firestoreData.isCompleted = BooleanField.toOfflineCache(this.isCompleted);
    firestoreData.isPrintable = BooleanField.toOfflineCache(this.isPrintable);

    return firestoreData;
  }
}
